/// <amd-module name="Build/Common/Artifacts/providers/SymbolRequest" />
import { Base } from "Build/Common/Artifacts/providers/Base";
import { BuildArtifactTypes } from 'Common';
export class SymbolRequest extends Base {
    public getKey() {
        return BuildArtifactTypes.SymbolRequest;
    }
}
